import type { GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import ErrorComponent from '../components/ErrorComponent';
import { MetaTagsComp } from '../components/MetaTagsComp';
import StudyDestination from '../components/StudyDestination';
import fetchUtil from '../utils/fetchUtil';

const StudyDestinations: NextPage = (props: any) => {
  const { meta } = props.pageData ?? {}

  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#6C48F0');
    customStyle.setProperty('--navbar-menu-color', '#ffffff')
  }, [])

  if (!props.pageData?.studycountries) {
    return <ErrorComponent />
  }

  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <StudyDestination {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  let pageData: any = {}
  try {
    pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/study-destinations-landing`, 'GET', {}, '', false)
  } catch (error) {
  }
  
  return {
    props: {
      pageData,
    }
  };
}

export default StudyDestinations;